var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": "right",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "单据号",
                                      prop: "documentNo",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.documentNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "documentNo",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.documentNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "报告期限从",
                                      prop: "monthFrom",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "value-format": "yyyy-MM",
                                        format: "yyyy-MM",
                                        type: "month",
                                      },
                                      model: {
                                        value: _vm.queryCondition.monthFrom,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "monthFrom",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.monthFrom",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "报告期限至",
                                      prop: "monthTo",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "value-format": "yyyy-MM",
                                        format: "yyyy-MM",
                                        type: "month",
                                      },
                                      model: {
                                        value: _vm.queryCondition.monthTo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "monthTo",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.monthTo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Category3",
                                      prop: "category3Code",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: _vm.isDisabled,
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.category3Code,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "category3Code",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.category3Code",
                                        },
                                      },
                                      _vm._l(
                                        _vm.category3CodeOptions,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.object,
                                              value: item.key,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "供应商",
                                              prop: "sponsorName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .sponsorName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "sponsorName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.sponsorName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "状态",
                                              prop: "status",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table:
                                                  "TT_RMC_PROTEIN_PURCHASE",
                                                field: "STATUS",
                                                excludes: _vm.excludesValue,
                                                clearable: "",
                                                placeholder: "请选择",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.status",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _vm.ms_roles.indexOf("QSPI_RMC_CHICK_BUYER_SUPP") !== -1 ||
            _vm.ms_roles.indexOf("QSPI_RMC_PORK_BUYER_SUPP") !== -1
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.RMC_PROT_PCQTY_ADD,
                        expression: "RMC_PROT_PCQTY_ADD",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.onAdd },
                  },
                  [_vm._v("新增")]
                )
              : _vm._e(),
            _vm.ms_roles.indexOf("QSPI_RMC_CHICK_BUYER_SUPP") !== -1 ||
            _vm.ms_roles.indexOf("QSPI_RMC_PORK_BUYER_SUPP") !== -1
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.RMC_PROT_PCQTY_DELETE,
                        expression: "RMC_PROT_PCQTY_DELETE",
                      },
                    ],
                    staticClass: "btn",
                    attrs: { size: "small", type: "danger" },
                    on: { click: _vm.onDel },
                  },
                  [_vm._v("删除")]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROT_PCQTY_ADMIN_DELETE,
                    expression: "RMC_PROT_PCQTY_ADMIN_DELETE",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "small", type: "danger" },
                on: { click: _vm.onAdminDel },
              },
              [_vm._v("删除")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROT_PCQTY_REPORT,
                    expression: "RMC_PROT_PCQTY_REPORT",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.onExport },
              },
              [_vm._v("导出")]
            ),
          ],
          1
        ),
        _c(
          "ux-grid",
          {
            ref: "plxTable",
            attrs: {
              data: _vm.tableData,
              "max-height": "600",
              "show-overflow": "tooltip",
              "highlight-current-row": "",
            },
            on: { "selection-change": _vm.selectionChange },
          },
          [
            _c("ux-table-column", {
              attrs: { align: "center", type: "checkbox", width: "80" },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "单据号",
                resizable: "",
                "min-width": "100",
                field: "documentNo",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.onDetail(row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(row.documentNo))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "报告期限",
                resizable: "",
                "min-width": "90",
                field: "month",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Category3",
                resizable: "",
                "min-width": "100",
                field: "category3Name",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "供应商",
                resizable: "",
                "min-width": "90",
                field: "sponsorName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "状态",
                resizable: "",
                "min-width": "120",
                field: "statusI18n",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "更新人",
                resizable: "",
                "min-width": "90",
                field: "updateName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "更新时间",
                resizable: "",
                "min-width": "120",
                field: "updateDate",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
                "page-count": _vm.pages,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "请选择",
              visible: _vm.dialogVisible,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
              close: _vm.onCancelExport,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "exportForm",
                attrs: {
                  model: _vm.exportForm,
                  rules: _vm.exportFormRules,
                  "label-width": "80px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "年", prop: "yearStr" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "value-format": "yyyy",
                                format: "yyyy",
                                type: "year",
                                placeholder: "选择年",
                              },
                              model: {
                                value: _vm.exportForm.yearStr,
                                callback: function ($$v) {
                                  _vm.$set(_vm.exportForm, "yearStr", $$v)
                                },
                                expression: "exportForm.yearStr",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Category3",
                              prop: "category3Code",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.exportForm.category3Code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.exportForm,
                                      "category3Code",
                                      $$v
                                    )
                                  },
                                  expression: "exportForm.category3Code",
                                },
                              },
                              _vm._l(
                                _vm.category3CodeLists,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.object,
                                      value: item.key,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onDownload },
                  },
                  [_vm._v("导出")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: { click: _vm.onCancelExport },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }